import { Box } from '@mui/material';
import { useContext } from 'react';
import { CircleBackground } from './CircleBackground';
import { DATA_TEST } from './enums';
import { ResultContext, sizeStyles } from './ResultContext';
import type { ResultIllustrationProps } from './types';

/**
 * Renders an illustration inside a fixed-size circular background.
 */
export const ResultIllustration = ({ sx = {}, children, dataTest }: ResultIllustrationProps) => {
  const context = useContext(ResultContext);
  if (!context) throw new Error('Graphic must be used within an Result component');

  const { size, isMobile } = context;
  const { spacing } = sizeStyles(size, isMobile);

  // Fixed circle size for illustrations
  const circleSize = 200;

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', mb: spacing }}
      data-test={dataTest ?? DATA_TEST.result_illustration}
    >
      <CircleBackground width={circleSize} height={circleSize}>
        <Box
          sx={{
            width: 150,
            height: 150,
            padding: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...sx,
            '& svg': {
              maxWidth: '100%',
              maxHeight: '100%'
            }
          }}
        >
          {children}
        </Box>
      </CircleBackground>
    </Box>
  );
};
